<template>
  <v-app>
    <div style="width: 95%; zoom: 0.95; margin: 0 auto; padding: 0px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: 10%;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="padding-left: 15px; padding-top: 10px; vertical-align: top;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt; font-weight: bold;">{{ getSetting('CompanyHeader', 'company', 'Company Name', 1)}}</span></p>
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getSetting('CompanyHeader', 'address', 'Address', 1)}}</span></p>
            <p v-if="getSetting('CompanyHeader', 'taxid', 0)!=null" style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getSetting('CompanyHeader', 'taxid', 'Tax Id', 1)}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="min-width: 35%; max-width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr v-if="route=='tax'">
                <td>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'ordernum2', 'Order Num', 2) }}</span>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'ordernum2', 'Order Num', 1) }}</span>
                </td>
                <td style="text-align: right; vertical-align: middle;"><span style="font-size: 11pt;">{{ (new Date(initvalue.salesorderdate)).getFullYear() + '-' + initvalue.salesordernum2 }}</span></td>
              </tr>
              <tr v-else>
                <td>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'ordernum', 'Order Num', 2) }}</span>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'ordernum', 'Order Num', 1) }}</span>
                </td>
                <td style="text-align: right; vertical-align: middle;"><span style="font-size: 11pt;">{{ initvalue.salesordernum }}</span></td>
              </tr>
              <tr v-if="initvalue.salesorderdate!=null">
                <td>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'orderdate', 'Order Date', 2) }}</span>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'orderdate', 'Order Date', 1) }}</span>
                </td>
                <td style="text-align: right; vertical-align: middle;"><span style="font-size: 11pt;">{{ new Date(initvalue.salesorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr v-if="initvalue.salesorderduedate!=null">
                <td>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'duedate', 'Due Date', 2) }}</span>
                  <span style="font-size: 11pt; font-weight: bold; display: block;">{{ getSetting('SalesOrderFormat', 'duedate', 'Due Date', 1) }}</span>
                </td>
                <td style="text-align: right; vertical-align: middle;"><span style="font-size: 11pt;">{{ new Date(initvalue.salesorderduedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%">
        <tr>
          <td>
            <div v-if="isHaveSetting('SalesOrderFormat', 'ordertype')==true" style="text-align: center;">
              <h4 class="ma-0"><b>{{ getSetting('SalesOrderFormat', 'ordertype', 'Sales Order', 2) }}</b></h4>
            </div>
            <div style="text-align: center;">
              <h5 class="ma-0"><b>{{ getSetting('SalesOrderFormat', 'ordertype', 'Sales Order', 1) }}</b></h5>
            </div>
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">{{ getSetting('SalesOrderFormat', 'customer', 'Customer', 2) }} {{ getSetting('SalesOrderFormat', 'customer', 'Customer', 1) }}</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesordername }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesorderaddress }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesorderphone }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesordermobile }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold;">Order Type</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertype }}</span></td>
              </tr>
              <tr v-if="initvalue.paymethodid!=null">
                <td><span style="font-size: 11pt; font-weight: bold">Pay Method</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_paymethod_name }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_location }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Sales Rep</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_user }}</span></td>
              </tr>

            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr v-if="isHaveSetting('SalesOrderFormat', 'quantity')==true">
            <th :style="css['row-left-mr']" width="2%"></th>
            <th :style="css['row-left-mr']">{{ getSetting('SalesOrderFormat', 'description', 'Description', 2) }}</th>
            <th :style="css['row-left-mr']" width="7%"></th>
            <th :style="css['row-left-mr']" width="10%">{{ getSetting('SalesOrderFormat', 'quantity', 'Quantity', 2) }}</th>
            <th :style="css['row-left-mr']" width="10%">{{ getSetting('SalesOrderFormat', 'price', 'Price', 2) }}</th>
            <th :style="css['row-right-ml']" width="15%">{{ getSetting('SalesOrderFormat', 'amount', 'Amount', 2) }}</th>
          </tr>
          <tr>
            <th :style="css['row-top-left']" width="2%">#</th>
            <th :style="css['row-top-left']">{{ getSetting('SalesOrderFormat', 'description', 'Description', 1) }}</th>
            <th :style="css['row-top-left']" width="7%"></th>
            <th :style="css['row-top-left']" width="10%">{{ getSetting('SalesOrderFormat', 'quantity', 'Quantity', 1) }}</th>
            <th :style="css['row-top-left']" width="10%">{{ getSetting('SalesOrderFormat', 'price', 'Price', 1) }}</th>
            <th :style="css['row-top-right']" width="15%">{{ getSetting('SalesOrderFormat', 'amount', 'Amount', 1) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']">{{ trans.itemname }}</td>
            <td :style="css['row-left-mr']">{{ trans.itemfoc }}</td>
            <td :style="css['row-left-mr']">{{ formatQuantity(trans) }}</td>
            <td :style="css['row-left-mr']">{{ formatPrice(trans) }}</td>
            <td :style="css['row-right-ml']">{{ formatAmount(trans) }}</td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr>
            <td colspan="6" style="vertical-align: text-top; ">
              <table width="100%">
                <tr>
                  <td style="max-width: 180px; vertical-align: top;">
                    <table width="100%">
                      <tr>
                        <td>
                          <p style="margin-bottom: 20px;"><strong>Note:</strong></p> <span style="white-space: pre">{{ initvalue.salesordernote }}</span>
                        </td>
                      </tr>
                      <tr v-if="data_paymethod!=null">
                        <td v-if="data_paymethod.paymethodtype=='Qr Code'" colspan="5"><p style="margin:0"><strong>{{ data_paymethod.paymethodcode }}</strong></p> <span style="white-space: pre"></span>
                          <div>
                            <img :src="data_paymethod.qrcodeimage" contain width="175">
                          </div>
                          <p style="margin:0"><strong>{{ data_paymethod.paymethodinfo }}</strong></p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="60%" style="align-content: start; vertical-align: top;">
                    <table v-if="initvalue.salesordertotal!=null" width="100%">
                      <tr v-if="initvalue.salesordertaxvalue!=null && getSetting('TaxSettings', 'displaytaxvalue', '0', 1)==true">
                        <td style="text-align: end; width: 50%;">
                          <span style="font-size: 11pt; font-weight: bold">{{ getSetting('SalesOrderFormat', 'taxvalue', 'Taxable Value', 2) }}&nbsp;{{ getSetting('SalesOrderFormat', 'taxvalue', 'Taxable Value', 1) }}:</span>
                        </td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordertaxvalue).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertaxvalue.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                      <tr v-if="getSetting('TaxSettings', 'displaytax', '0', 1)==true">
                        <td style="text-align: end; width: 50%;">
                          <span style="font-size: 11pt; font-weight: bold">{{ getSetting('SalesOrderFormat', 'tax', 'Tax', 2) }}&nbsp;{{ getSetting('SalesOrderFormat', 'tax', 'Tax', 1) }}</span>
                          <span style="font-size: 11pt; font-weight: bold">&nbsp;{{ parseFloat(getSetting('TaxSettings', 'taxrate', "0", 1))*100 }}%:</span>
                        </td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordertaxamount).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertaxamount.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                      <tr>
                        <td style="text-align: end; width: 25%;">
                          <span style="font-size: 11pt; font-weight: bold">{{ getSetting('SalesOrderFormat', 'subtotal', 'Subtotal', 2) }}&nbsp;{{ getSetting('SalesOrderFormat', 'subtotal', 'Subtotal', 1) }}:</span>
                        </td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordersubtotal).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordersubtotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                      <tr>
                        <td style="text-align: end; width: 25%;">
                          <span style="font-size: 11pt; font-weight: bold">{{ getSetting('SalesOrderFormat', 'total', 'Total', 2) }}&nbsp;{{ getSetting('SalesOrderFormat', 'total', 'Total', 1) }}:</span>
                        </td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordertotal).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                      <tr>
                        <td style="text-align: end; width: 25%;">
                          <span style="font-size: 11pt; font-weight: bold">{{ getSetting('SalesOrderFormat', 'rate', 'Currency Rate', 2) }}&nbsp;{{ getSetting('SalesOrderFormat', 'rate', 'Currency Rate', 1) }}:</span>
                        </td>
                        <td style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.currencyRate.toFixed(2) }} </span></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr><td colspan="6">&nbsp;</td></tr>

        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../../util/tools';

export default {
  name: 'PrintSalesOrder',
  props: {
    id: String,
    route: String,
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
      css: {
        'row-top-right': 'text-align: right; border-bottom: 1px; border-bottom-style: solid',
        'row-top-left': 'text-align: left; border-bottom: 1px; border-bottom-style: solid',
        'row-left-mr': 'vertical-align: top; text-align: left; padding-right: 5px;',
        'row-right-ml': 'vertical-align: top; text-align: right; padding-left: 5px;',
        'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
        'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
      },
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getSalesOrderRequest', 'getCompanyDataRequest']),
    getSetting(code, name, value, route){
      if(this.data_company.companysettings==null || this.data_company.settings.length==0) return null;
      let results = this.data_company.companysettings.find(i=>i.settingcode==code);

      let data = results!=null && results.settingdata!=null && results.settingdata!='' ? JSON.parse(`[${results.settingdata}]`) : [];
      let result = data.find(i=>i.name==name);
      if(result==null) return;

      let value1 = result!=null ? result.value : '';
      let value2 = result!=null ? result.value2 : '';
      if(route==1) {
        if(value1=='' || value1==null) return value;
        return value1;
      }
      if(route==2) {
        if(value2=='' || value2==null) return null;
        return value2;
      }
      return value;
    },
    isHaveSetting(code, name){
      if(this.data_company.companysettings==null || this.data_company.settings.length==0) return false;
      console.log('0')
      let results = this.data_company.companysettings.find(i=>i.settingcode==code);
      console.log('0',results)
      if(results==null) return false;
      console.log('1')
      let data = results!=null && results.settingdata!=null && results.settingdata!='' ? JSON.parse(`[${results.settingdata}]`) : [];
      let result = data.find(i=>i.name==name);
      console.log('2')
      if(result==null) return false;
      return true;
    },
    data_account(id){
      if(this.data_company.accounts==null || this.data_company.accounts.length==0) return null;
      let account = this.data_company.accounts.find(i=>i._id == id);
      if(account!=null) return account['accountcode'];
      return '';
    },
    data_item(id){
      if(this.data_company.items==null || this.data_company.items.length==0) return null;
      let item = this.data_company.items.find(i=>i._id == id);
      if(item!=null) return item['itemname'];
      return '';
    },
    convertCurrency(amount){
      let rate = parseFloat(this.initvalue.currencyRate);
      if(rate==null) rate = 0;
      return amount * rate;
    },
    formatQuantity(trans){
      let result;
      if(trans==null || trans.itemquantity==null) return 0;
      if(trans.itemfoc=='Foc' || trans.itemfoc=='Promo') result = trans.itemquantity.toFixed(3);
      else {
        if(trans.itemquantity<1) result = trans.itemquantity.toFixed(1);
        else result = trans.itemquantity.toFixed(0);
      }
      return result;
    },
    formatPrice(trans){
      let result;
      if(trans==null || trans.itemprice==null) return 0;
      else result = trans.itemprice.toFixed(2);
      return result;
    },
    formatAmount(trans){
      let result;
      if(trans==null || trans.itemamount==null) return 0;
      else result = trans.itemamount.toFixed(2);
      return result;
    },
  },
  computed: {
    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.length==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationname'];
      return '';
    },
    data_user(){
      if(this.data_company.users==null || this.data_company.users.length==0) return null;
      let user = this.data_company.users.find(i=>i._id == this.initvalue.userid);
      if(user!=null) return user['username'];
      return '';
    },
    data_paymethod(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod;
      return null;
    },
    data_paymethod_name(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod['paymethodname'];
      return null;
    }
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getSalesOrderRequest(this.id);
      if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
      console.log(this.data_company)
    }
  },
}

</script>

<style src="./../Print.scss" lang="scss"/>
